module.exports = __webpack_public_path__ + "img/collection-weddingRingsSlim@2x.b2ac35c.jpg";